"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const adyen_web_1 = __importDefault(require("@adyen/adyen-web"));
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const i18next_1 = __importDefault(require("i18next"));
const mobx_1 = require("mobx");
const AdyenPaymentMethodsResponseStore_1 = __importDefault(require("./AdyenPaymentMethodsResponseStore"));
const ShopwareContext_1 = __importDefault(require("./ShopwareContext"));
class AdyenCheckoutStore {
    internalLoading = false;
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            internalLoading: mobx_1.observable,
            isLoading: mobx_1.computed,
        });
    }
    get isLoading() {
        return this.internalLoading;
    }
    create(clientKey) {
        const environment = ShopwareContext_1.default.adyenEnvironment;
        if (!environment || !clientKey) {
            return Promise.resolve(null);
        }
        this.internalLoading = true;
        return AdyenPaymentMethodsResponseStore_1.default.loadAdyenPaymentMethodsResponse()
            .then((response) => {
            if (!response) {
                return null;
            }
            const configuration = {
                clientKey,
                environment,
                locale: i18next_1.default.language,
                paymentMethodsResponse: response,
                showPayButton: false,
            };
            return (0, adyen_web_1.default)(configuration);
        })
            .finally(() => {
            this.internalLoading = false;
        });
    }
}
__decorate([
    bind_decorator_1.default
], AdyenCheckoutStore.prototype, "create", null);
exports.default = new AdyenCheckoutStore();
